/**
 * @namespace Share
 * @aka SWR.Share
 */
SWR.Share = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'share';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-share]'
  };

  var DefaultType = {
    share: 'string'
  };

  /*
   TODO: private helpers go here.
   */

  function prepareLink(source, $encoded) {
    var url = new URL(location.origin + location.pathname);
    var search_params = url.searchParams;
    search_params.set('at_medium', 'social');
    search_params.set('at_campaign', 'info@swr.de');
    search_params.set('at_source', source.toLowerCase());

    // change the search property of the main url
    url.search = search_params.toString();
    // the new url string
    var link = url.toString();

    if (false !== $encoded) {
      link = encodeURIComponent(link);
    }
    return link;
  }


  /**
   * Adds missing "https://" and ending slash to the URL
   *
   * @param {string} url URL to normalize
   * @return {string} normalized URL
   */
  function normalizeUrl(url) {
    if (-1 === url.indexOf("http://") && -1 === url.indexOf("https://")) {
      url = "https://" + url;
    }
    if (url.charAt(url.length - 1) !== "/") {
      url = url + "/";
    }
    return url;
  }

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Share = function () {

    function Share(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      console.log("SHARE", self.$element);

      self._alignShareIcons();

      //Kopieren der Sharing-Buttons
      //Ist nur mobil relevant
      var $target = $('footer .meta-bottom').closest(".container");
      if (0 === $target.prev('.container.sharing-bottom').length) {
        var $sharing = $('.sharing').clone();
        $target.before($sharing);
        $sharing.wrap('<div class="container sharing-bottom"></div>');
      }

      self.$element.on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        self.share();
      });
    }

    Share.prototype._alignShareIcons = function _alignShareIcons() {
      // scroll triggeres the scroll bases alignment
      $(window).scroll(alignShareIcon);
      // resize must remove sticky class when no longer in tab mode
      $(window).resize(alignShareIcon);

      /**
       * Triggers the restyling of the share buttons, on tablet bp sizes, when needed during `resize` or `scroll`
       */
      function alignShareIcon() {
        var grid = new Grid();

        var social = $('.sharing');
        if (0 !== social.length) {
          // only execute when there is some sharing at all on the page
          var list_group = $('.list-group', social);

          if (grid.isBp(['sm', 'md', 'lg', 'xl'])) {
            if ($(window).scrollTop() > social.offset().top && $('#footer')[0].offsetTop > ($(window).scrollTop() + social[0].offsetTop)) {
              // when user scrolled past the sharing buttons
              // and the sharing buttons do not overlap the footer
              if (!social.hasClass('sticky')) {
                // but sticky is not already initialised

                // as sticky changes the height, but height must be set after `sticky` change
                var social_init_height = social.height();

                social.addClass('sticky');
                social.css({
                  height: social_init_height
                });
              }
            } else {
              // when user scrolled back over the sharing buttons
              social.removeClass('sticky');
              social.removeAttr('style');
              list_group.removeAttr('style');
            }
          } else {
            // when breakpoint is smaller, than sm
            social.removeClass('sticky');
            social.removeAttr('style');
            list_group.removeAttr('style');
          }
        }
      }
    };

    Share.prototype.share = function share(element) {
      var self = this;
      self.element = element || this.element;

      var config = extend({}, $(self.element).data());
      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      var share = config.share;
      if (typeof self[share] === 'undefined') {
        throw new TypeError('No method named "' + share + '"');
      }
      self[share]();
    };

    Share.prototype.mastodon = function mastodon() {
      console.log("mastodon");
      if (true === COMMON.isOpen) {
        return;
      }

      /**
       * Modalfenster
       */
      var id = COMMON.Utils.uuid();
      var $modalHeader = COMMON.Utils.modalHeader('Bei Mastodon teilen');
      var $modalBody = COMMON.Utils.modalBody('' +
        '<form class="form form-modal" data-pjax="false" method="get" style="width: 100%; max-width: 550px">' +
        '  <div class="form-group" data-required="true">' +
        '    <datalist id="mastodon-instanz-datalist"></datalist>' +
        '    <label for="mastodon-instanz">Mastodon-Server wählen</label>' +
        '    <input id="mastodon-instanz" name="instanz" list="mastodon-instanz-datalist" type="url" class="form-control" autocomplete="off" required placeholder="https://" />' +
        '    <p class="help-block">Für die Liste der Mastodon-Server werden Daten an <em>api.joinmastodon.org</em> übermittelt.</p>' +
        '  </div>' +
        '  <div class="form-group">' +
        '    <div class="checkbox">' +
        '      <label for="mastodon-remember">' +
        '        <input type="checkbox" id="mastodon-remember" name="remember">' +
        '        <span class="form-control-indicator"></span> Mastodon-Server in diesem Browser merken.' +
        '      </label>' +
        '    </div>' +
        '  </div>' +
        '  <button type="submit" class="btn btn-primary">Jetzt bei Mastodon teilen!</button>' +
        '</form>');
      var $modalFooter = COMMON.Utils.modalFooter('<p class="small">Mit diesem Klick verlassen Sie das Webangebot von SWR.de, für die folgende Seite ist der SWR nicht verantwortlich.</p>');
      var $modal = $(COMMON.Utils.modalDialog(id, $modalHeader, $modalBody, $modalFooter));
      $modal.addClass('modal-extended');
      $modal.addClass('share-mastodon');

      var $inputInstanz = $modal.find('input#mastodon-instanz');
      var $datalistInstanz = $modal.find('datalist#mastodon-instanz-datalist');

      var instanceURL = COMMON.Storage.local.getItem('mastodon-instanz')
      if (instanceURL) {
        $inputInstanz.val(instanceURL);
        $modal.find('input#mastodon-remember').prop('checked', true);
      }

      /*
       * Modalfenster wurde geschlossen
       */
      $modal.on('hidden.bs.modal', function () {
        $modal.modal('dispose');
        $modal.off();
        $modal.remove();
        $modal = null;

        COMMON.isOpen = false;
      });

      // Close on navigate
      $(document).one('pjax:beforeReplace', function (event) {
        if ($modal) {
          $modal.trigger('hidden.bs.modal');
        }
      });


      $inputInstanz.on('focus', function (event) {
        if (0 !== $datalistInstanz.children().length) {
          return;
        }

        /*
         * Fetch API
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
         */
        var apiRequestUrl = new URL('https://api.joinmastodon.org/servers');

        fetch(apiRequestUrl.toString(), {
          headers: {
            'Accept': 'application/json, */*; q=0.01'
          },
          method: 'GET'
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('Request rejected with status ' + response.status + ' and message ' + response.statusText);
          }
          return response.json();
        }).then(function (data) {
          var instanceDomains = data.map(function (item) {
            return item.domain;
          })
          instanceDomains.sort();

          instanceDomains.forEach(function (instanceDomain) {
            var $option = $('<option />');
            $option.val(normalizeUrl(instanceDomain));
            $datalistInstanz.append($option)
          });
        }).catch(function (exception) {
          console.error('Couldn\'t load instance list');
          (console.error || console.log).call(console, exception.stack || exception);
        })
      });

      var $form = $modal.find('form');
      $form.on('submit', function (event) {

        event.stopPropagation();
        event.preventDefault();

        var formData = new FormData(this);

        var instanceURL = formData.get('instanz') || 'https://mastodon.social/';
        if (formData.has('remember')) {
          console.info('URL zwischenspeichern');
          COMMON.Storage.local.setItem('mastodon-instanz', instanceURL);
        }

        var shareURL = new URL('share', instanceURL);
        var text = 'Schau mal, was ich auf SWR.de gefunden habe: ' + prepareLink('Mastodon', false);
        shareURL.search = new URLSearchParams({
          text: text
        }).toString();

        /*
         * Verfügbarkeit prüfen
         */
        // $.ajax({
        //   url: shareURL.toString(),
        //   dataType: 'text',
        //   type: 'GET'
        // }).done(function (data, textStatus, jqXHR) {

        window.open(shareURL.toString(), undefined, 'status=no,resizable=yes,scrollbars=yes,personalbar=no,directories=no,location=no,toolbar=no,menubar=no,width=550,height=450,noopener,noreferrer');

        $modal.modal('hide');
        // }).fail(function (jqXHR, textStatus, errorThrown) {
        //   console.warn('Invalid response: ', textStatus, errorThrown);
        // })
      });

      $modal.appendTo('body');
      $modal.modal({
        backdrop: 'static',
        focus: false
      });

      COMMON.isOpen = true;
    }

    Share.prototype.facebook = function facebook() {
      var shareLink = new URL('https://www.facebook.com/sharer/sharer.php');
      shareLink.searchParams.set('u', prepareLink('Facebook', false));
      window.open(shareLink.toString(), undefined, 'status=no,resizable=yes,scrollbars=yes,personalbar=no,directories=no,location=no,toolbar=no,menubar=no,width=626,height=436,noopener,noreferrer');
    };

    Share.prototype.twitter = function twitter() {
      var shareLink = new URL('https://twitter.com/intent/tweet');
      shareLink.searchParams.set('text', 'Schau mal, was ich auf SWR.de gefunden habe: ');
      shareLink.searchParams.set('related', 'SWR.de');
      shareLink.searchParams.set('dnt', 'true');
      shareLink.searchParams.set('lang', 'de');
      shareLink.searchParams.set('via', 'SWR.de');
      shareLink.searchParams.set('url', prepareLink('X', false));
      window.open(shareLink.toString(), undefined, 'status=no,resizable=yes,scrollbars=yes,personalbar=no,directories=no,location=no,toolbar=no,menubar=no,width=550,height=450,noopener,noreferrer');
    };

    Share.prototype.x = function x() {
      var shareLink = new URL('https://twitter.com/intent/tweet');
      shareLink.searchParams.set('text', 'Schau mal, was ich auf SWR.de gefunden habe: ');
      shareLink.searchParams.set('related', 'SWR.de');
      shareLink.searchParams.set('dnt', 'true');
      shareLink.searchParams.set('lang', 'de');
      shareLink.searchParams.set('via', 'SWR.de');
      shareLink.searchParams.set('url', prepareLink('X', false));
      window.open(shareLink.toString(), undefined, 'status=no,resizable=yes,scrollbars=yes,personalbar=no,directories=no,location=no,toolbar=no,menubar=no,width=550,height=450,noopener,noreferrer');
    };

    Share.prototype.whatsapp = function whatsapp() {
      var shareLink = new URL('https://wa.me/');
      shareLink.searchParams.set('text', 'Schau mal, was ich auf SWR.de gefunden habe: ' + prepareLink('WhatsApp', false));
      window.open(shareLink.toString(), undefined, 'status=no,resizable=yes,scrollbars=yes,personalbar=no,directories=no,location=no,toolbar=no,menubar=no,width=600,height=460,noopener,noreferrer');
    };

    // public
    Share.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Share._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Share(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Share;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Share._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Share._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Share._jQueryInterface;
  $.fn[NAME].Constructor = Share;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Share._jQueryInterface;
  };

  return Share;

})(window.jQuery);


/****
 * Fügt Buttons zum Kopieren einer URL
 * entsprechende Attribute hinzu,
 * sodass das JS zum Kopieren regaieren kann.
 * ***/
(function ($) {

  var Event = {
    PJAX_DATA_API: 'pjax:end'
  };
  var Selector = {
    DATA_SPY: '[data-share=copy]'
  };

  var fixElements = function () {
    return this.each(function () {
      var $element = $(this);

      $element
        .attr('data-spy', 'clipboard')
        .attr('data-clipboard-text', location.origin + location.pathname)

      // bind ClipboardJS to $button
      $element.clipboard()
    })
  };

  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    fixElements.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      fixElements.call($element);
    });
  });

})(window.jQuery);
